<footer class="bg-secondary-prune p-4 text-white">
  <div class="container mx-auto">footer works!</div>
</footer>
